import { useDispatch, useSelector } from 'react-redux';
import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import { ajaxErrorMiddleware } from '@wikom/wikom-data';
import httpErrorMiddleware from '@app/middlewares/httpErrorMiddleware';
import rootReducer from '@app/rootReducer';
// @ts-ignore
var composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
var configure = function (_a, ROUTE) {
    var replace = _a.replace;
    return (createStore(rootReducer, composeEnhancers(applyMiddleware(thunk, ajaxErrorMiddleware('/'), httpErrorMiddleware({
        403: ROUTE.PAGE.COMMON.ACCESS_DENIED(),
        503: ROUTE.PAGE.COMMON.WARTUNG()
    }, replace)))));
};
export var useAppDispatch = function () { return useDispatch(); };
export var useAppSelector = useSelector;
export default configure;
